import { createReducer } from "@reduxjs/toolkit";
import { resetAll, setPath } from "../actions";
const initialState = {
    present: "/",
    future: [],
    past: [],
};
export const pathReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setPath, (state, action) => {
        const { payload } = action;
        const { path, initial, backtrack } = payload;
        if (initial) {
            state.past = [];
            state.future = [];
        }
        if (backtrack) {
            const lastIndex = state.past.lastIndexOf(path);
            if (lastIndex >= 0) {
                // remove the path from the past and move the past to the future
                const past = state.past.slice(0, lastIndex);
                const future = [...past.slice(0, -1), ...state.future];
                state.past = past;
                state.future = future;
            }
        }
        else {
            // add the previous path to the past and reset the future
            state.past = [...state.past, state.present];
            state.future = [];
        }
        // update the present
        state.present = path;
    })
        .addCase(resetAll, () => {
        return initialState;
    });
});
//# sourceMappingURL=pathReducer.js.map